import { useTranslation } from 'react-i18next';

const TIERS = [
  { tier: 1,  share: '20%', group: 'diamond' },
  { tier: 2,  share: '10%', group: 'platinum' },
  { tier: 3,  share: '5%',  group: 'gold' },
  { tier: 4,  share: '5%',  group: 'gold' },
  { tier: 5,  share: '5%',  group: 'gold' },
  { tier: 6,  share: '5%',  group: 'gold' },
  { tier: 7,  share: '5%',  group: 'gold' },
  { tier: 8,  share: '3%',  group: 'silver' },
  { tier: 9,  share: '3%',  group: 'silver' },
  { tier: 10, share: '3%',  group: 'silver' },
  { tier: 11, share: '1%',  group: 'bronze' },
  { tier: 12, share: '1%',  group: 'bronze' },
  { tier: 13, share: '1%',  group: 'bronze' },
  { tier: 14, share: '1%',  group: 'bronze' },
  { tier: 15, share: '1%',  group: 'bronze' },
  { tier: 16, share: '1%',  group: 'bronze' },
  { tier: 17, share: '1%',  group: 'bronze' },
];

const GROUPS = [
  { key: 'diamond',  single: 1,  share: '20%', count: 1 },
  { key: 'platinum', single: 2,  share: '10%', count: 1 },
  { key: 'gold',     from: 3,  to: 7,  share: '5%',  count: 5 },
  { key: 'silver',   from: 8,  to: 10, share: '3%',  count: 3 },
  { key: 'bronze',   from: 11, to: 17, share: '1%',  count: 7 },
];

const PartnerProgramSection = () => {
  const { t } = useTranslation();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="partners" className="section-x partners">
      <div className="dot-grid dot-grid--subtle" />
      <div className="gold-orb gold-orb--primary partners__orb" />

      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center mb-5">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('partnerProgram.eyebrow')}</span>
            </div>
            <h2 className="section-heading" data-aos="fade-up">
              {t('partnerProgram.titleLead')}{' '}
              <span className="gold-text">{t('partnerProgram.titleHighlight')}</span>
            </h2>
            <p className="section-subheading" data-aos="fade-up" data-aos-delay="80">
              {t('partnerProgram.subtitle')}
            </p>
          </div>
        </div>

        {/* Pull quote */}
        <div className="partners__pullquote" data-aos="zoom-in" data-aos-delay="100">
          <div className="partners__pullquote-number gold-text tabular-nums">71%</div>
          <div className="partners__pullquote-text">
            <strong>{t('partnerProgram.pullquoteStrong')}</strong>{' '}
            {t('partnerProgram.pullquoteRest')}
          </div>
        </div>

        {/* Group summary cards */}
        <div className="row g-3 mb-5 justify-content-center">
          {GROUPS.map((g, i) => (
            <div key={g.key} className="col-lg col-md-4 col-sm-6">
              <div
                className={`gen-group gen-group--${g.key}`}
                data-aos="fade-up"
                data-aos-delay={i * 60}
              >
                <div className="gen-group__share tabular-nums">{g.share}</div>
                <div className="gen-group__label">
                  {g.single
                    ? t('partnerProgram.tierN', { n: g.single })
                    : t('partnerProgram.tiersRange', { from: g.from, to: g.to })}
                </div>
                <div className="gen-group__count mono">
                  {g.count === 1
                    ? t('partnerProgram.oneGeneration')
                    : t('partnerProgram.nGenerations', { count: g.count })}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Detailed 17-tier grid */}
        <div className="partners__detailed" data-aos="fade-up">
          <h5 className="partners__detailed-title">{t('partnerProgram.fullBreakdown')}</h5>
          <div className="gens-grid">
            {TIERS.map((lvl, i) => (
              <div
                key={lvl.tier}
                className={`gen-card gen-card--${lvl.group}`}
                data-aos="fade-up"
                data-aos-delay={i * 20}
              >
                <div className="gen-card__header mono">{t('partnerProgram.tierShort')}&nbsp;{lvl.tier}</div>
                <div className="gen-card__share tabular-nums">{lvl.share}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Conditions */}
        <div className="row g-3 mt-4">
          <div className="col-lg-4" data-aos="fade-up">
            <div className="cond-card">
              <div className="cond-card__num mono">01</div>
              <p>{t('partnerProgram.condition1')}</p>
            </div>
          </div>
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="80">
            <div className="cond-card">
              <div className="cond-card__num mono">02</div>
              <p>{t('partnerProgram.condition2')}</p>
            </div>
          </div>
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="160">
            <div className="cond-card">
              <div className="cond-card__num mono">03</div>
              <p>{t('partnerProgram.condition3')}</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="partners__cta" data-aos="fade-up">
          <button
            type="button"
            className="tg-btn tg-btn-lg"
            onClick={() => scrollToSection('hero')}
          >
            <i className="fas fa-link" />
            {t('partnerProgram.ctaPrimary')}
            <i className="fas fa-arrow-right" />
          </button>
          <button
            type="button"
            className="tg-btn-two tg-btn-lg"
            onClick={() => scrollToSection('calculator')}
          >
            {t('partnerProgram.ctaSecondary')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PartnerProgramSection;
